export default __webpack_public_path__ + "static/media/038-travel bag.8791762d.svg";